import React from 'react'
import SixDotsSvg from '@/shared/assets/images/DotsSixVertical.svg'
import UserSvg from '@/shared/assets/images/User.svg'
import { Link } from "react-router-dom";
import { NodeModel } from '@minoru/react-dnd-treeview';
import { GroupUserNode } from '@/entities/groups';
import { useUserAccrualModal } from '@/features/user-accrual';
import { DropdownButton } from '@/shared/ui/dropdown-button';
import { DropdownItem } from '@/shared/ui/dropdown-item';
import AccrualSvg from '@/shared/assets/images/Coins.svg'
import { getDisplayName } from '@/entities/user';

interface TreeGroupUserNodeProps {
    node: NodeModel<GroupUserNode>
    depth: number
}

export const TreeGroupUserNode: React.FC<TreeGroupUserNodeProps> = ({ depth, node }) => {
    const { openUserAccrualModal } = useUserAccrualModal()
    return (
        depth === 1
            ? <div className={`pt-3`}>
                <div className="flex px-2 py-3 border-b bg-white border-[#E7EAEE] items-center justify-between">
                    <div className='flex w-full justify-between items-center'>
                        <div className="flex items-center gap-2">
                            <SixDotsSvg width={24} height={24} />
                            <div className="bg-color-dark text-white rounded-full h-9 w-9 flex items-center justify-center">
                                <UserSvg width={24} height={24} />
                            </div>
                            <Link to={`/users/profile/${node.data.id}`} className="hover:underline font-semibold text-[13px]">
                                {getDisplayName(node.data)}
                            </Link>
                        </div>
                        <DropdownButton>
                            <DropdownItem
                                icon={AccrualSvg}
                                label="Начислить бонусы"
                                onClick={() => openUserAccrualModal({ id: node.data.id })}
                            />
                        </DropdownButton>
                    </div>
                </div>
            </div>
            : <div className={`pt-3`}>
                <div
                    style={{
                        margin: `0 ${depth * 4}px`
                    }}
                    className={`flex px-2 py-3 rounded-[4px] bg-[#F8F8F8] border-b border-[#E7EAEE] items-center justify-between`
                    }>
                    <div className='flex w-full justify-between items-center'>
                        <div className="flex items-center gap-2">
                            <SixDotsSvg width={24} height={24} />
                            <div className="bg-color-dark text-white rounded-full h-9 w-9 flex items-center justify-center">
                                <UserSvg width={24} height={24} />
                            </div>
                            <Link to={`/users/profile/${node.data.id}`} className="hover:underline font-semibold text-[13px]">
                                {getDisplayName(node.data)}
                            </Link>
                        </div>
                        <DropdownButton>
                            <DropdownItem
                                icon={AccrualSvg}
                                label="Начислить бонусы"
                                onClick={() => openUserAccrualModal({ id: node.data.id })}
                            />
                        </DropdownButton>
                    </div>
                </div>
            </div>
    )
}